import {
  StyledTextField,
  TextboxWrapper,
} from "./MultilineTextbox.styles"
  
export interface Props {
  label: string
  lines: number
  value?: string | number | null | undefined | readonly string[]
  onChange?: (e: any) => void
  type?: string
  disabled:boolean
}

export default function MultilineText(props: Props) {
  return (
    <TextboxWrapper>
      <StyledTextField
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        fullWidth
        multiline
        rows={props.lines}
        InputLabelProps={{
          shrink: true,
        }}
        type={props.type}
        disabled={props.disabled}
      />
    </TextboxWrapper>
  )
}
